<template>
  <div class="empty-state">
    <img v-if="image" v-bind:src="require(`@/assets/img/${image}`)" />
    <p v-if="description">{{description}}</p>
    <ima-button 
      v-if="act" 
      class="btn-empty-state" 
      :variant="secondary ? 'secondary': 'primary'"
      :title="callToAction" 
      :act="act">
    </ima-button>
  </div>
</template>

<script>
import ImaButton from "../components/shared/ImaButton.vue";

export default {
  components: {
    ImaButton,
  },
  props: {
    callToAction: {
      type: String,
      required: false
    },
    image: {
      type: String,
      required: false
    },
    description: {
      type: String
    },
    act: {
      type: Function,
      required: false
    },
    //TODO: refactor this primary/secondary
    primary: {
      type: Boolean,
      required: false
    },
    secondary: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style scoped lang="scss">
@use '@/styles/theme.scss';

.empty-state {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  width: calc( 100% - 60px);
  height: 50%;
}

.empty-state img {
  box-sizing: border-box;
  width: 100%;
  height: 50%;
  margin-bottom: 20px;
  max-height: 300px;
}

.empty-state.simple {
  position: initial;
  width: initial;
}

.empty-state p {
  margin-bottom: 20px;
  text-align: center;
}

.empty-state .btn-empty-state {
  margin: auto;
}

.white-text p {
  color: theme.$text-white;
}

.custom-modal-content .empty-state {
  width: 100%;
}

// style for list page
@media screen and (max-width: 600px) {
  .list-page.empty-state {
    position: initial;
    top: initial;
    -webkit-transform: initial;
    transform: initial;
    width: initial;
  }
}

@media (min-width: 768px) { 
  .empty-state{ 
    width: calc(100% - 360px);
  }

  .evaluate .empty-state,
  .list-evaluate .empty-state {
    width: initial;
    left: 50%;
    transform: translate(-50%,-50%);  
  }

  .custom-modal-content .empty-state img {
    height: 120px;
  }
  
}

@media screen and (max-width: 330px) {
   .list-page.empty-state {
    top: 65%;
  }

  .list-page img {
    max-height: 75px;
  }
}
</style>